import V1 from './v1/EducationModuleV1'
import { IModule } from '@/contracts/core/module/interface/IModule'
import { Provider } from '@/contracts/core/provider/entity/Provider'

export class EducationModuleProvider extends Provider<IModule> {
  realizations: Record<string, IModule> = {
    v1: V1(),
  }
}

const instance: { module: IModule | null } = { module: null }

export default function EducationModuleProviderModule(): IModule {
  const version = 'v1'

  if(!instance.module){
    instance.module = new EducationModuleProvider().module(version)
  }

  return instance.module
}
